import styled from 'styled-components';
import { media } from 'app/utils/style';
import { colors } from 'app/variables';

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 2rem;

  ${media.mediumHigh`
    padding: initial;
  `}
`;
export const Image = styled.img`
  width: auto;
  max-width: 100%;
  min-height: 5rem;
  max-height: 12.5rem;
  border-radius: 10px;
  object-fit: cover;

  ${media.mediumHigh`
    object-fit: contain;
    max-height: 14rem;
  `}
  ${media.mediumDesktop`
    max-height: 18rem;
  `}
`;
export const BuyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  height: 100%;
  align-items: initial;
  margin-left: 0;
  padding: 0;

  ${media.mediumDesktop`
    gap: 2.5rem;
    padding-left: 2rem;
    margin-left: -1.5rem;
    align-items: center;
    line-height: 14px;
    border-left: 1px solid ${colors.gallery};
  `}
`;
export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: center;
  gap: 2rem;
  width: 100%;
  height: 100%;
`;
export const BuyForm = styled.div`
  display: flex;
  flex-direction: column;
  margin 0 2rem;
  ${media.mediumDesktop`
    margin: 0px;
  `}
`;
export const BuyLabel = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.emperor};
  font-weight: 400;
  margin: 0 2rem;

  ${media.mediumDesktop`
    margin: 0;
    gap: 2.5rem;
    font-size: 1.5rem;
    font-weight: 600;
  `}
`;

export const Title = styled.div`
  display: block;
  margin 0 2rem;
  font-size: 1.75rem;
  font-weight: 600;

  ${media.mediumDesktop`
    display: none;
  `}
`;
export const TimeSpan = styled.div`
  display: block;
  margin 0 2rem;
  font-weight: 400;
  ${media.mediumDesktop`
    display: none;
  `}

`;
export const DetailsInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 2rem;
  height: 100%;

  ${media.mediumDesktop`
    display: none;
  `}
`;
